import React, { Component, ReactNode } from 'react'
import AuthCard from './AuthCard'
import Button from './Button'
import InputText from './InputText'
import { i18n } from "../i18n/i18n";

interface Props {
  heading: string
  username: string
  password: string
  progress: boolean
  children: ReactNode
  onInputChange: (name: string, value: string) => void
  onSignInClick: () => void
}

export default class SignInCard extends Component<Props> {
  render () {
    return (
      <AuthCard
        heading={this.props.heading}
        description={i18n("Please sign in")}>
        <InputText
          label={i18n("Username")}
          name="username"
          value={this.props.username}
          onChange={this.props.onInputChange} />
        <InputText
          label={i18n("Password")}
          name="password"
          value={this.props.password}
          type="password"
          onChange={this.props.onInputChange} />
        <Button
          text={i18n("Sign In")}
          full={true}
          onClick={this.props.onSignInClick} />
        {this.props.children}
      </AuthCard>
    )
  }
}
